import { Subscription } from 'rxjs';

// ANGULAR
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import {
  Component,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';

// PACKAGES
import moment from 'moment';

// SERVICES
import { FileService } from '../../../data/services/file.service';
import { EventsService } from '../../../data/services/events.service';
import { CookieService } from 'ngx-cookie-service';

// UTILS
import { FileUtils } from '../../../data/utils/file.utils';

// MODELS
import { Event } from '../../../data/models/interfaces/event';
import { TreeNode } from '../../../data/models/interfaces/tree-node.interface';

//Tree Services
import { TreeProfilesService } from '../../../data/services/tree-services/tree-profiles.service';

import { MatDatetimePickerInputEvent } from '@angular-material-components/datetime-picker';
import { createDateRangeValidator } from '../../../data/utils/date-range-validator.util';
import { LinkYearsClassrooms } from '../../../data/models/dto/link-years-classrooms';
import { ClassRoomsService } from '../../../data/services/classroom.service';
import { classroomsReducedText } from '../../../data/utils/classroom.utils';
import { confirmationBottomSheet } from '../../../data/utils/bottom-sheet-confirmation.utils';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { CustomSnackbarService } from '../../components/custom-snackbar/custom-snackbar-service';
import { ClassroomFilterDto } from '../../../data/models/dto/classroom-filter.dto';
import { UserUtil } from '../../../data/utils/user.utils';
import { FileDto } from '../../../data/models/dto/file.dto';
import { MANAGEMENT_ADVISOR_PROFILES, RESTRICTED_ROUTE_PROFILES } from '../../../data/utils/profile.utils';

@Component({
  selector: 'app-event',
  templateUrl: './event.component.html',
  styleUrls: ['./event.component.scss'],
})
export class EventComponent implements OnInit, OnDestroy {

  profilesElegibleToManageEvents = RESTRICTED_ROUTE_PROFILES(MANAGEMENT_ADVISOR_PROFILES);

  // EVENT DATA
  isUpdate: boolean = false;
  eventId: string | undefined;
  event: Event | undefined;

  boxContour: string = 'div-file-upload-contour';
  isEnableCleanButton: boolean = false;

  eventForm: FormGroup = this.fb.group(
    {
      title: new FormControl({ value: '', disabled: false }, [
        Validators.required,
      ]),
      description: new FormControl({ value: '', disabled: false }, [
        Validators.required,
      ]),
      location: new FormControl({ value: '', disabled: false }),
      startDate: new FormControl({ value: '', disabled: false }, [
        Validators.required,
        Validators.minLength(1),
      ]),
      endDate: new FormControl({ value: '', disabled: false }),
    },
    {
      validators: [createDateRangeValidator()],
    }
  );

  //BUTTON TREE
  destDefaultText: string = 'Adicione um ou mais destinatários';
  destSelectedText: string = this.destDefaultText;
  textButtonLinkYearClassrooms: string = 'Adicione uma ou mais turmas';
  textclassroomYear: string = '';
  checkedIdsClassrooms: string[] = [];

  //Profiles
  treeRespProfiles: TreeNode | undefined;
  respProfilesSelectedText: string = '';
  treeRespProfilesSelected: boolean = false;

  // DATE TIME PICKER
  cleardtTmPicker: boolean = false;

  //MESSAGES
  successSaveMessage = '';
  errorSaveMessage = '';
  succcessDeleteMessage = '';
  errorDeleteMessage = '';

  //ROLES VIEWS
  isButtonDest: boolean = false;
  isButtonClassrooms: boolean = false;
  isFormVisible: boolean = false;

  eventSubscription: Subscription = new Subscription();
  startTxtYear = '';

  filter: ClassroomFilterDto = {
    year: this.startTxtYear,
    idSchool: this.schools[0].id,
  };

  attachments: any[] = [];
  attachmentsToDelete: FileDto[] = [];
  currentAttachments: any[] = [];
  bgFiles: any[] = [];
  bgFilesToDelete: FileDto[] = [];
  currentBgFiles: any[] = [];
  backgroundFilePath = '';
  attachmentsPath = '';

  constructor(
    private bottomSheet: MatBottomSheet,
    // SERVICES
    private readonly eventsService: EventsService,
    private readonly filesService: FileService,
    private readonly cookieService: CookieService,

    //TREE SERVICES
    private readonly treeProfilesService: TreeProfilesService,
    private readonly classroomsServive: ClassRoomsService,

    // ROUTER
    private router: Router,
    private route: ActivatedRoute,

    // AUX
    private fb: FormBuilder,
    private snackbarService: CustomSnackbarService,
    private fileUtils: FileUtils,
    private readonly userUtil: UserUtil
  ) {
    this.route.params.subscribe((params: Params) => {
      this.eventId = params['id'];
      if (this.eventId) {
        this.isUpdate = true;
      }
    });
  }

  ngOnDestroy(): void {
    this.eventSubscription.unsubscribe();
  }

  ngOnInit(): void {
    if (this.eventId) {
      this.getEvent(this.eventId);
    } else {
      this.initEvent();
      this.initData();
    }
    this.loadChangesForm();
  }

  onCurrentAttachmentsEmit(emit: FileDto[]) {
    this.currentAttachments = emit;
  }
  onAttachmentsToDeleteEmit(emit: FileDto[]) {
    this.attachmentsToDelete = emit;
  }

  onCurrentBackgroundFileEmit(emit: FileDto[]) {
    this.currentBgFiles = emit;
  }
  onBackgroundFileToDeleteEmit(emit: FileDto[]) {
    this.bgFilesToDelete.push(...emit);
  }

  private get schools() {
    return this.userUtil.getSchools();
  }

  loadChangesForm() {
    this.eventForm.valueChanges.subscribe(() => {
      if (
        this.eventForm.controls['title'].value ||
        this.eventForm.controls['description'].value ||
        this.eventForm.controls['location'].value ||
        this.eventForm.controls['startDate'].value ||
        this.eventForm.controls['endDate'].value
      ) {
        this.isEnableCleanButton = true;
        this.isFormVisible = true;
      } else {
        this.isEnableCleanButton = false;
        this.isFormVisible = false;
      }
      if (this.eventForm.controls['startDate'].value == 'Invalid Date')
        this.eventForm.controls['startDate'].setErrors({ incorrect: true });
    });
    this.defineButtonText();
  }

  private initData() {
    this.loadForm(this.event);
    this.loadFiles();
    this.loadMessagesText();
    this.createTreeRespProfiles();
  }

  private initEvent(): void {
    this.event = <Event>{
      id: undefined,
      title: '',
      description: '',
      year: new Date().getFullYear().toString(),
      location: '',
      type: 'Event',
      active: true,
      backgroundFile: '',
      files: [],
      idsProfiles: [],
      idsClassRooms: [],
      startDate: null,
      endDate: null,
      confirmationDate: undefined,
      idSchool: '',
    };
  }

  private loadMessagesText() {
    this.successSaveMessage = this.isUpdate
      ? 'Evento atualizado com sucesso!'
      : 'Evento salvo com sucesso!';
    this.errorSaveMessage = this.isUpdate
      ? 'Erro ao atualizar o evento!'
      : 'Erro ao salvar o evento!';
    this.succcessDeleteMessage = 'O evento foi excluído';
    this.errorDeleteMessage = 'Erro ao remover o evento!';
  }

  // ============================ EVENT METHODS =========================== //
  getEvent(id: string) {
    this.eventSubscription = this.eventsService
      .getById(id)
      .subscribe((response) => {
        if (response) {
          this.event = response;

          this.initData();
          this.textclassroomYear = this.event?.year!;
          this.checkedIdsClassrooms = this.event?.idsClassRooms!;
          this.loadClassroomsSegmentTree(this.filter);

          if (
            this.event.backgroundFile &&
            typeof this.event.backgroundFile === 'string'
          )
            this.backgroundFilePath = `events/background/${this.eventId}`;
          if (
            this.event.files &&
            this.event.files.length > 0 &&
            typeof this.event.files[0] === 'string'
          )
            this.attachmentsPath = `events/${this.eventId}`;
        }
      });
  }

  saveEvent() {
    this.eventForm.disable();
    let event = this.createEvent(this.currentBgFiles, this.currentAttachments);
    if (this.isUpdate) this.update(event);
    else this.save(event);
    this.bgFilesToDelete.forEach((f) => {
      this.filesService.delete(f.id!).toPromise();
    });
    this.attachmentsToDelete.forEach((f) => {
      this.filesService.delete(f.id!).toPromise();
    });
  }

  private save(event: Event) {
    this.eventSubscription = this.eventsService.save(event).subscribe(
      (res) => {
        this.snackbarService.showNotification(this.successSaveMessage, 2000);
        setTimeout(() => {
          this.router.navigate(['events-list']);
        }, 1500);
      },
      (error) => {
        console.error(error);
        this.snackbarService.showNotification(this.errorSaveMessage, 2000);
      }
    );
  }

  private update(event: Event) {
    this.eventSubscription = this.eventsService.update(event).subscribe(
      (res) => {
        this.snackbarService.showNotification(this.successSaveMessage, 2000);
        setTimeout(() => {
          this.router.navigate(['events-list']);
        }, 1500);
      },
      (error) => {
        console.error(error);
        this.snackbarService.showNotification(this.errorSaveMessage, 2000);
      }
    );
  }

  async deleteCurrentEvent() {
    const confirmation = await confirmationBottomSheet(
      this.bottomSheet,
      'Você tem certeza que deseja excluir este evento?',
      'Cancelar',
      'Excluir',
      'custom-bottom-sheet-container'
    );
    if (confirmation) {
      if (this.eventId) {
        this.eventsService.remove(this.eventId).subscribe(
          () => {
            this.snackbarService
              .showNotification(this.succcessDeleteMessage, 2000)
              .afterDismissed()
              .toPromise()
              .then(() => {
                this.router.navigate(['events-list']);
              });
          },
          () => {
            this.snackbarService.showNotification(
              this.errorDeleteMessage,
              2000
            );
          }
        );
      }
    }
  }

  createEvent(
    backgroundFile: FileDto[] | string[] | undefined,
    attachFiles: FileDto[] | string[] | undefined
  ): Event {
    let background: string | FileDto | null = null;
    if (backgroundFile && backgroundFile.length > 0)
      background = backgroundFile[0];
    let event = {
      id: this.eventId,
      files: attachFiles,
      location: this.eventForm.value.location,
      type: 'Event',
      active: true,
      description: this.eventForm.value.description,
      year: this.event?.year
        ? this.event?.year
        : new Date().getFullYear().toString(),
      backgroundFile: background,
      idsProfiles: this.event?.idsProfiles,
      idsClassRooms: this.event?.idsClassRooms,
      startDate:
        this.eventForm.value.startDate === null
          ? null
          : moment(this.eventForm.value.startDate).utc(false).toDate(),
      title: this.eventForm.value.title,
      confirmartionDate: undefined,
      endDate:
        this.eventForm.value.endDate === null
          ? null
          : moment(this.eventForm.value.endDate).utc(false).toDate(),
      confirmationDate: undefined,
      idSchool: this.schools[0].id,
    };
    return event;
  }

  loadForm(event: Event | undefined) {
    if (event) {
      this.eventForm.reset({
        title: event.title,
        description: event.description,
        location: event.location,
        startDate: moment(event.startDate).utc(false).toDate(),
        endDate: moment(event.endDate).utc(false).toDate(),
      });
    }
  }

  clearInputFields() {
    this.eventForm.reset();
    if (this.cleardtTmPicker) this.cleardtTmPicker = false;
    else this.cleardtTmPicker = true;
  }

  loadFiles() {
    this.bgFiles = this.event?.backgroundFile
      ? [this.event?.backgroundFile]
      : [];
    this.currentBgFiles = this.bgFiles;

    this.attachments = this.event?.files ?? [];
    this.currentAttachments = this.attachments;
  }

  fileExtension(fileName: string) {
    return this.fileUtils.fileExtension(fileName);
  }

  formatBytes(size: number) {
    return this.fileUtils.formatBytes(size);
  }

  isImage(name: string) {
    return this.fileUtils.isImage(name);
  }

  dtTmSelected(dtType: string, value: MatDatetimePickerInputEvent<Date>) {
    this.eventForm.controls[dtType].setValue(
      moment(value.value).utc(false).toDate()
    );
  }

  // =================== TREE METHODS ============== //

  createTreeRespProfiles() {
    this.treeProfilesService
      .createTreeProfiles(
        this.event?.idsProfiles,
        'Todos (Aluno + Responsáveis)'
      )
      .subscribe((treeNode) => {
        const treeProfilesAux = treeNode;
        this.treeRespProfiles = { ...treeProfilesAux };
        this.treeRespProfiles!.children = [];
        this.treeRespProfiles!.id = 'allRespProfiles';
        treeNode.children?.forEach((child) => {
          if (
            child.name?.toLowerCase().includes('respons') ||
            child.name?.toLowerCase().includes('aluno')
          )
            this.treeRespProfiles?.children?.push(child);
        });
        if (this.treeRespProfiles) {
          this.formatSelectedAllProfilesTexts();
        }
      });
  }

  private async loadClassroomsSegmentTree(filter: ClassroomFilterDto): Promise<void> {
    const tree = await this.classroomsServive.getTree(filter).toPromise();
    let classrooms = '';
    tree.forEach((segment) => {
      segment.series?.forEach((serie) => {
        serie.classRooms?.forEach((classroom) => {
          if (this.event?.idsClassRooms!.includes(classroom.id!)) {
            if (classrooms === '') classrooms += classroom.name;
            else classrooms += ', ' + classroom.name;
          }
        });
      });
    });
    this.textButtonLinkYearClassrooms = classrooms;
  }

  updateCheckedClassroom(tree: LinkYearsClassrooms) {
    this.textButtonLinkYearClassrooms = tree.classrooms
      ? tree.classrooms
      : 'Adicione uma ou mais turmas';
    this.textclassroomYear = tree.year;
    this.checkedIdsClassrooms = tree.idsClassrooms;
    this.textButtonLinkYearClassrooms = classroomsReducedText(
      this.textButtonLinkYearClassrooms
    );
    this.event!.idsClassRooms = tree.idsClassrooms;
    this.event!.year = tree.year;
    this.isButtonClassrooms = true;
  }

  updateSelectedProfiles(treeNode: TreeNode[]) {
    const respProfileTree = treeNode.find((x) => x.id == 'allRespProfiles');

    if (respProfileTree) this.selectedRespProfiles(respProfileTree);
  }

  selectedRespProfiles(treeNode: TreeNode) {
    const idsRespProfilesUpdated =
      this.treeProfilesService.updateSelectedProfiles(
        treeNode,
        this.event?.idsProfiles
      );
    if (idsRespProfilesUpdated && this.event) {
      this.event.idsProfiles = [];
      this.event.idsProfiles.push(...idsRespProfilesUpdated);
    }
    this.formatSelectedAllProfilesTexts();
  }

  private formatSelectedAllProfilesTexts() {
    if (this.treeRespProfiles) {
      this.treeRespProfilesSelected = this.treeProfilesService.hasCheckedItems(
        this.treeRespProfiles
      );
      if (this.treeRespProfilesSelected) {
        const countRespProfilesSelected =
          this.treeProfilesService.countCheckeds(this.treeRespProfiles);
        if (countRespProfilesSelected > 0) {
          if (this.destSelectedText !== this.destDefaultText) {
            const splitProfilesText = this.destSelectedText.split(' +');
            const countCheckedProfiles =
              splitProfilesText.length > 1 ? Number(splitProfilesText[1]) : 0;
            const countChecked: number =
              countRespProfilesSelected + countCheckedProfiles - 1;
            if (countChecked > 0)
              this.destSelectedText = splitProfilesText[0]
                .concat(' +')
                .concat(countChecked.toString());
          } else {
            this.respProfilesSelectedText =
              this.treeProfilesService.formatSelectedsText(
                this.treeRespProfiles
              );
            this.destSelectedText = this.respProfilesSelectedText;
            this.isButtonDest = true;
          }
        }
      }
    }
  }

  private formatSelectedClassroomsTexts() {
    console.log('dadada')
    // if (this.treeSegments) {
    //   this.treeSegmentsSelected = this.treeSegmentsService.hasCheckedItems(
    //     this.treeSegments
    //   );
    //   if (this.treeSegmentsSelected) {
    //     this.segmentsSelectedText =
    //       this.treeSegmentsService.formatSelectedsText(this.treeSegments!);
    //     this.isButtonSegments = true;
    //   } else {
    //     this.segmentsSelectedText = '';
    //     this.segmentsSelectedText = this.segmentsSelectedText;

    //     if (this.segmentsSelectedText == '')
    //       this.segmentsSelectedText = this.segmentsDefaultText;
    //     this.isButtonSegments = false;
    //   }
    // }
  }

  get formVisible(): boolean {
    return (this.isButtonClassrooms && this.isButtonDest) || this.isFormVisible;
  }

  inProgressText = '';
  saveButtonText = '';
  saveInProgress = false;
  defineButtonText(): void {
    if (this.isUpdate) {
      this.inProgressText = 'Salvando';
      this.saveButtonText = 'Salvar';
    } else {
      this.inProgressText = 'Criando';
      this.saveButtonText = 'Criar';
    }
  }

  handleSaveButtonClicked() {
    this.saveInProgress = true;
    this.saveEvent();
  }
}
